export default __webpack_public_path__ + "static/media/sports05.cd816f69.jpg";